module.exports = __webpack_public_path__ + "img/home-pic-1.ec4a6651.jpg";